/**
 * MenuLabel is the only always visible part of Menu.
 * Clicking it toggles visibility of MenuContent.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './MenuLabel.module.css';

class MenuLabel extends Component {
  constructor(props) {
    super(props);

    this.state = { clickedWithMouse: false };
    this.onClick = this.onClick.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  onClick(e) {
    e.stopPropagation();
    e.preventDefault();
    this.props.onToggleActive();

    // Don't show focus outline if user just clicked the element with mouse
    // tab + enter creates also a click event, but its location is origin.
    const { nativeEvent } = e;
    const isRealClick = !(nativeEvent.clientX === 0 && nativeEvent.clientY === 0);
    if (isRealClick) {
      this.setState({ clickedWithMouse: true });
    }
  }

  onBlur() {
    this.setState(() => ({ clickedWithMouse: false }));
  }

  render() {
    const {
      id,
      children,
      className,
      rootClassName,
      isOpen,
      isOpenClassName,
      onMouseEnter,
      onMouseLeave,
      ariaLabel,
      contentId,
    } = this.props;

    const rootClass = rootClassName || css.root;
    const isOpenClass = isOpenClassName || css.isOpen;
    const classes = classNames(rootClass, className, {
      [css.clickedWithMouse]: this.state.clickedWithMouse,
      [isOpenClass]: isOpen,
    });

    return (
      <button
        id={id}
        className={classes}
        onClick={this.onClick}
        onBlur={this.onBlur}
        type="button"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        {...(ariaLabel && { 'aria-label': ariaLabel })}
        aria-controls={contentId}
      >
        {children}
      </button>
    );
  }
}
/* eslint-enable jsx-a11y/no-static-element-interactions */

MenuLabel.defaultProps = {
  id: null,
  className: null,
  isOpenClassName: null,
  isOpen: false,
  onToggleActive: null,
  onMouseEnter: null,
  onMouseLeave: null,
  rootClassName: '',
  ariaLabel: null,
  contentId: null,
};

const { bool, func, node, string } = PropTypes;

MenuLabel.propTypes = {
  id: string,
  children: node.isRequired,
  className: string,
  isOpenClassName: string,
  isOpen: bool,
  onToggleActive: func,
  onMouseEnter: func,
  onMouseLeave: func,
  rootClassName: string,
  ariaLabel: string,
  contentId: string,
};

export default MenuLabel;
